import { Epg, Layout } from "@nessprim/planby";

// Import hooks
import { useApp } from "./useApp";

// ----- Please uncomment the following lines to see the custom components -----
// Import components
import {
  CustomTimeline,
  ChannelItem,
  Line,
  LiveTime,
  Program,
} from "./components";

function App() {
  const { isLoading, getEpgProps, getLayoutProps, getLayoutData, setSnap } =
    useApp();

  return (
    <div>
      <div style={{ margin: 10, display: "flex" }}>
        <a id="downloadAnchor" style={{ display: "none" }}></a>

        <button
          onClick={() => {
            const dataStr =
              "data:text/json;charset=utf-8," +
              encodeURIComponent(
                JSON.stringify(getLayoutData(getLayoutProps().programs))
              );
            const dlAnchorElem = document.getElementById("downloadAnchor");
            dlAnchorElem?.setAttribute("href", dataStr);
            dlAnchorElem?.setAttribute("download", "planbyLayoutDemoData.json");
            dlAnchorElem?.click();
          }}
        >
          Download Layout Data
        </button>
        <div>
          <label
            id="snap"
            style={{ marginLeft: 15, display: "flex", alignItems: "center" }}
          >
            <span>DnD snap X</span>
            <input type="checkbox" id="snap" onChange={() => setSnap()} />{" "}
          </label>
        </div>
      </div>
      <div style={{ height: "770px", width: "99%" }}>
        <Epg isLoading={isLoading} {...getEpgProps()}>
          <Layout
            {...getLayoutProps()}
            // ----- Please uncomment the following lines to see the custom components -----
            // renderLine={(props) => <Line {...props} />}
            // renderCurrentTime={(props) => <LiveTime {...props} />}
            // renderTimeline={(props) => <CustomTimeline {...props} />}
            // renderProgram={({ program, ...rest }) => (
            //   <Program
            //     key={`${program.data.channelUuid}-${program.data.id}`}
            //     program={program}
            //     {...rest}
            //   />
            // )}
            renderChannel={({ channel, ...rest }) => (
              <ChannelItem key={channel.uuid} channel={channel} {...rest} />
            )}
          />
        </Epg>
      </div>
    </div>
  );
}

export default App;
